import React from "react";
import "./SidebarNavigation.css";
import CompanyLogo from "../../../assets/images/futuresoft_logo.png";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { Menu } from "lucide-react";
import { useSidebarNavigation } from "../../../customHooks/SidebarNavigation/useSidebarNavigation";

const SidebarNavigation = () => {
  const {
    openSelectStore,
    setOpenSelectStore,
    selectedStoreId,
    search,
    loading,
    error,
    allStores,
    sidebarCollapsed,
    brandName,
    tenantName,
    isAdmin,
    toggleSidebar,
    handleStoreSearch,
    handleChangeStore,
    handleLogout,
    isTabActive,
    getFilteredNavigationItems,
  } = useSidebarNavigation();

  // --- Render ---
  return (
    <div className="sidebar-container">
      <div className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <div className="logo-section">
            {!sidebarCollapsed && (
              <div className="logo-text">
                <div className="brand-name">
                  <img className="OndcLogo" src={CompanyLogo} alt="Logo" />
                </div>
                {!isAdmin ? (
                  <div className="brand-subtitle">Welcome, {tenantName}</div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
          <button
            className="sidebar-toggle"
            onClick={toggleSidebar}
            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <Menu />
          </button>
        </div>
        <nav className="nav-section">
          {getFilteredNavigationItems().map((item) => (
            <div key={item.id} className="nav-item">
              <Link
                to={item.path}
                className={`nav-link ${isTabActive(item.path) ? "active" : ""}`}
                title={sidebarCollapsed ? item.label : ""}
              >
                <div className="nav-content">
                  <item.icon className="nav-icon" />
                  {!sidebarCollapsed && (
                    <span className="nav-text">{item.label}</span>
                  )}
                </div>
                {isTabActive(item.path) && <div className="active-indicator" />}
              </Link>
            </div>
          ))}
        </nav>

        {isAdmin && (
          <div className="d-flex justify-content-left p-3">
            <div className="store-container">
              <div className="active-store">
                <span className="label">Active Store:</span>
                <span className="name">{brandName || "No store selected"}</span>
              </div>
              <button
                onClick={() => setOpenSelectStore(true)}
                className="btn btn-primary btn-sm px-4 py-2 text-white font-weight-bold rounded-3 shadow-sm hover:shadow-lg transition-all"
                style={{ fontSize: "0.875rem" }}
              >
                Change Store
              </button>
            </div>
          </div>
        )}

        {/* User/Logout Section */}
        <div className="user-section">
          <button
            className="logout-button"
            onClick={handleLogout}
            title="Logout"
          >
            <FiLogOut size={20} /> {!sidebarCollapsed && <span>Logout</span>}
          </button>
        </div>
      </div>

      {/* Change Store Modal */}
      <Modal
        centered
        show={openSelectStore}
        onHide={() => setOpenSelectStore(false)}
      >
        <Modal.Header closeButton>Change Store</Modal.Header>
        <Modal.Body>
          <div className="store-selector-card">
            <div className="search-section">
              <div className="search-input-group">
                <input
                  type="search"
                  name="search"
                  id="storeSearch"
                  value={search}
                  onChange={handleStoreSearch}
                  className="form-control search-input"
                  placeholder="Search tenants by name..."
                />
              </div>
            </div>
            {/* Display list based on the flattened allStores array */}
            <div
              className="accordion-body p-2"
              style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              {loading ? (
                <div className="text-muted text-center py-3">Loading...</div>
              ) : error ? (
                <div className="text-danger text-center py-3">{error}</div>
              ) : allStores.length > 0 ? (
                allStores.map((store) => (
                  <div
                    key={store.id}
                    className={`card mb-2 border-0 shadow-sm ${
                      selectedStoreId === store.id
                        ? "border-primary bg-info bg-opacity-25"
                        : ""
                    }`}
                    onClick={() => handleChangeStore(store)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body d-flex align-items-center p-2">
                      <img
                        src={store.brand_logo}
                        alt={store.brand_name}
                        className="me-3 rounded border"
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/60";
                        }}
                      />
                      <div>
                        <h6 className="mb-0 text-truncate">
                          {store.brand_name} ({store.type})
                        </h6>
                        <small className="text-muted">ID: {store.id}</small>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center py-3">
                  No stores available.
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SidebarNavigation;
